import React from "react";

import "./index.scss";

const DoubleArrowIcon = ({ classes, height, width }) => (
  <div className={classes || ""}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width || 11} height={height || 11} viewBox="0 0 11 11" className="double-arrow">
      <g id="Arrows" transform="translate(-4155 -17639)">
        <path
          id="Path_8647"
          data-name="Path 8647"
          d="M0,9.782,4.522,5.261,0,.739.74,0,6,5.261.74,10.521Z"
          transform="translate(4155 17645) rotate(-90)"
          className="cls-2"
        />
        <path
          id="Path_15861"
          data-name="Path 15861"
          d="M0,9.782,4.522,5.261,0,.739.74,0,6,5.261.74,10.521Z"
          transform="translate(4155 17649) rotate(-90)"
          className="cls-2"
        />
      </g>
    </svg>
  </div>
);

export default DoubleArrowIcon;
